import styled from "styled-components";
export const StyledAnchor = styled.a `
  display: inline-flex;
  align-items: center;

  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};
  text-decoration: none;
  cursor: pointer;

  padding-right: ${({ isAnchor, isBackToSection }) => isAnchor ? "0" : isBackToSection ? "1rem" : "0.5rem"};

  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  box-sizing: border-box;

  background-color: ${({ isAnchor, theme }) => isAnchor ? `rgba(${theme.colors.transparentBlack}, .8)` : "transparent"};
  color: ${({ isAnchor, theme }) => isAnchor ? theme.colors.white : theme.colors.black};

  ${({ isAnchor }) => (isAnchor ? "width: 3rem;" : "")};
  ${({ isAnchor }) => (isAnchor ? "height: 3rem;" : "height: 2.5rem;")};

  ${({ maxWidth }) => maxWidth
    ? `
      max-width: ${maxWidth}px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `
    : ""};

  ${({ alignByContent }) => alignByContent === false
    ? ""
    : alignByContent === "left"
        ? "transform :translateX(-0.75rem);"
        : "transform :translateX(0.75rem);"};

  span:not(:nth-child(2)) {
    width: ${({ isAnchor }) => (isAnchor ? "3rem" : "2rem")};
    display: flex;
    justify-content: center;

    svg {
      fill: ${({ isAnchor, theme }) => isAnchor ? theme.colors.white : theme.colors.black};
    }
  }

  :hover {
    background-color: ${({ isAnchor, theme }) => isAnchor
    ? `rgba(${theme.colors.transparentBlack}, .6)`
    : `rgba(${theme.colors.transparentBlack}, .08)`};
  }

  :focus-visible {
    border-color: ${({ theme }) => theme.colors.primaryLight};
    outline: ${({ theme }) => `1px solid ${theme.colors.primaryLight}`};
  }

  :active {
    background-color: ${({ isAnchor, theme }) => isAnchor ? theme.colors.black : theme.colors.grey15};
    color: ${({ theme }) => theme.colors.white};

    span:not(:nth-child(2)) {
      svg {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
